<template>
    <div class="card p-3 h-100 shadow-sm border border-light" style="cursor: pointer;"
        @click="$emit('open-pre-court', person)">
        <div class="d-flex justify-content-between align-items-center mb-0" style="padding-top: 2px;">
            <h6 class="text-dark d-flex align-items-center gap-2">
                <i class="fa fa-user text-secondary me-1" style="font-size:14px;"></i>
                {{ person.personType === 1 ? 'Fiziki şəxs' : 'Hüquqi şəxs' }}

                <span v-if="isExecutorView" class="badge text-white  px-3 py-1" :style="{
                    backgroundColor: obligation.has === true ? '#dc3545' : '#28a745',
                    fontSize: '12px'
                }">
                    {{ obligation.has === true ? 'ÖHDƏLİK VAR' : 'ÖHDƏLİK YOXDUR' }}
                </span>

                <i v-if="statusColor === 'green'" title="İşə xitam verilib" class="fa-solid fa-circle-check"
                    style="color: #28a745 !important; font-size:13px;"></i>

                <i v-if="statusColor === 'orange'" title="İş davam edir" class="fa-solid fa-circle"
                    style="color: #fd7e14 !important; font-size:12px;"></i>

                <i v-if="statusColor === 'red'" title="İşə xitam verilib" class="fa-solid fa-circle"
                    style="color: #dc3545 !important; font-size:12px;"></i>
            </h6>
            <div class="d-flex align-items-center">
                <el-button class="fs-5" type="text" style="padding: 0px;" :icon="Edit" title="Düzəliş et" size="large"
                    :disabled="lastStatus === 50" @click.stop="$emit('edit', person)">
                </el-button>
                
                <!-- <button type="button" style="margin-bottom: 0;" class="btn btn-sm bg-white shadow-none p-0"
                    title="Düzəliş et" :disabled="lastStatus === 50" @click.stop="$emit('edit', person)">
                    <i class="fa-regular fa-edit text-muted fs-5"></i>
                </button> -->

                <el-button v-if="showDelete" class="fs-5" type="danger" style="padding: 0px !important;" :icon="Delete"
                    text @click="$emit('delete', person)">
                </el-button>
                <!-- <el-button v-if="showDelete" type="text" size="large" title="Sil" style="padding: 0px;" class="ms-2"
                    @click="$emit('delete', person)">
                    <div class="square-icon">
                        <i class="fa-regular fa-trash-can fs-5" style="color: #d33;"></i>
                    </div>
                </el-button> -->
            </div>

        </div>
        <hr style="margin-top:0;" />
        <div class="row" style="color: #606266; font-size: 14px;">
            <div v-if="person.personType === 1" class="col-md-6 mb-2">
                <span class="font-weight-bold">A.S.A:</span>&nbsp;
                <span class="value">{{ person.name + " " + person.surname + " " + person.fatherName }}</span>
            </div>
            <div v-if="person.personType === 2" class="col-md-6 mb-2">
                <span class="font-weight-bold">Ad:</span>&nbsp;
                <span class="value">{{ person.name }}</span>
            </div>
            <div v-if="person.personType === 1" class="col-md-6 mb-2">
                <span class="font-weight-bold">FİN:</span> &nbsp;
                <span class="value">{{ person.pin }}</span>
            </div>
            <div v-if="person.personType === 2" class="col-md-6 mb-2">
                <span class="font-weight-bold">VÖEN:</span> &nbsp;
                <span class="value">{{ person.tin }}</span>
            </div>
            <div v-if="person.personType === 2" class="col-md-6 mb-2">
                <span class="font-weight-bold">Nümayəndə:</span> &nbsp;
                <span class="value">{{ person.representative }}</span>
            </div>
            <div v-if="person.personType === 1" class="col-md-6 mb-2">
                <span class="font-weight-bold">Cins:</span>&nbsp;
                <span class="value">{{ person.gender === 1 ? 'Kişi' : person.gender === 2 ? 'Qadın' : '' }}</span>
            </div>
            <div v-if="person.personType === 1" class="col-md-6 mb-2">
                <span class="font-weight-bold">Doğum tarixi:</span> &nbsp;
                <span class="value">{{ formatDate(person.birthDate) }}</span>
            </div>
            <div class="col-md-6 mb-2">
                <span class="font-weight-bold">Nömrə:</span> &nbsp;
                <span class="value">{{ person.phone }} , {{ person.additionalPhone }}</span>
            </div>
            <div v-if="person.personType === 1" class="col-md-6 mb-2">
                <span class="font-weight-bold">İş yeri:</span> &nbsp;
                <span class="value"> {{ person.workPlace }}</span>
            </div>
            <div class="col-md-6 mb-2">
                <span class="font-weight-bold">Faktiki yaşayış ünvanı:</span> &nbsp;
                <span class="value"> {{ person.regAddress }}</span>
            </div>
            <div v-if="obligation.has && obligation.amount" class="col-md-6 mb-2">
                <span class="font-weight-bold">Öhdəlik məbləği:</span> &nbsp;
                <span class="value"> {{ obligation.amount }}</span>
            </div>
        </div>


    </div>
</template>

<script>
import { LastParticipantStatus } from "../Source/participants.js"
import { Delete, Edit } from "@element-plus/icons-vue";
export default {
    props: {
        isExecutorView: {
            type: Boolean,
            default: false
        },
        person: {
            type: Object,
            required: true
        },
        statusColor: {
            type: String,
            default: null
        },
        obligation: {
            type: Object,
            default: () => ({ has: null, amount: null })
        },
        showDelete: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            Delete,
            Edit,
            lastStatus: null,
            participantId: this.person.id
        };
    },
    mounted() {
        this.getLastParticipantStatus();
    },
    methods: {
        getLastParticipantStatus() {
            LastParticipantStatus(this.participantId)
                .then(response => {
                    this.lastStatus = response.data;
                })
                .catch(error => {
                    console.error("Failed to load last status:", error);
                });
        },
        formatDate(dateString) {
            if (!dateString) return '—';
            const date = new Date(dateString);
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = date.getFullYear();
            return `${day}.${month}.${year}`;
        }
    }
};
</script>
<style scoped>
.value {
    color: #222222;
}
</style>
